import axios from 'axios';
import { getUrl } from './service-utils';
import authHeader from './auth-header';

const API_URL = getUrl();

const processImage = async (imageBase64OrDataUrl: string) => {
  const res = await axios.post(
    API_URL + 'ai/process-image',
    { imageBase64OrDataUrl },
    { headers: authHeader() }
  );
  return res.data;
};

const aiService = { processImage };

export default aiService;
